<template>
  <div class="duplicateremovalDialog">
    <el-dialog :visible.sync="duplicateremovalVisible" center :show-close="false"
               custom-class="duplicateremoval" :before-close="handleClose">
      <template slot="title">
        <DialogsHeader :title="$t('memoryBankV2.duplicateremoval')" />
      </template>
      <template v-if="!loadingcompleted">
        <div class="duplicateremoval-content">
          <el-progress type="circle" :percentage="percentage" max- :stroke-width="10"
                       color="#0078fc">
          </el-progress>
          <div class="duplicateremoval-text">{{$t('memoryBankV2.Deduplicationinprogress')}}</div>
        </div>
        <template slot="footer">
          <el-button size="small" @click="handlerStop">{{$t('memoryBankV2.suspension')}}</el-button>
        </template>
      </template>
      <template v-else>
        <div class="duplicateremovalsuccess-content">
          <div class="success-img">
            {{$t('memoryBankV2.Deduplicationsucceeded')}}
          </div>
          <ul class="result">
            <li class="result-item">
              <el-tooltip effect="dark" :disabled="showTitle"
                          :content="$t('memoryBankV2.Anidenticalsentencepairintheoriginalandtranslation')"
                          placement="top-start">
                <div class="item-title" @mouseover="mouseOverShowTips($event)">
                  {{$t('memoryBankV2.Anidenticalsentencepairintheoriginalandtranslation')}}</div>
              </el-tooltip>
              <span class="item-num">{{resultInfo.sourceTargetSame.dealCount}} <em>
                  {{$t('memoryBankV2.strip')}}</em></span>
              <div class="item-state">{{formateStatus(resultInfo.sourceTargetSame.dealStatus)}}
              </div>
            </li>
            <li class="result-item">
              <el-tooltip effect="dark" :disabled="showTitle"
                          :content="$t('memoryBankV2.Sentencepairswiththesameoriginalanddifferenttranslations')"
                          placement="top-start">
                <div class="item-title" @mouseover="mouseOverShowTips($event)">
                  {{$t('memoryBankV2.Sentencepairswiththesameoriginalanddifferenttranslations')}}
                </div>
              </el-tooltip>
              <span class="item-num">{{resultInfo.sourceSameTargetDifferent.dealCount}}
                <em>{{$t('memoryBankV2.strip')}}</em></span>
              <div class="item-state "
                   :class="{tohandle:parseInt(resultInfo.sourceSameTargetDifferent.dealCount)>0}"
                   @click="handlerto(resultInfo.sourceSameTargetDifferent.dealCount)">
                {{formateStatus(resultInfo.sourceSameTargetDifferent.dealStatus)}}</div>
            </li>
          </ul>
        </div>
        <template slot="footer">
          <el-button size="small" @click="handleClose">{{$t('project.close')}}</el-button>
          <el-button size="small" type="primary"
                     v-if="resultInfo.sourceSameTargetDifferent.dealCount>0" @click="tohandle">
            {{$t('memoryBankV2.Tohandle')}}</el-button>
        </template>
      </template>
    </el-dialog>
    <!-- 待处理页面 -->
    <duplicateremoval-pending ref="duplicateremovalpending" :bankType="bankType"
                              :duplicateremovalPendingVisible="duplicateremovalPendingVisible"
                              @handleClose='closepending' @handle="handle">

    </duplicateremoval-pending>
  </div>
</template>
<script>
//标题组件
import DialogsHeader from '@/common/dialogsHeader';
import duplicateremovalPending from "../components/duplicateremovalPending";
import {
  memoryRemoveDeduplication,
  getRemoveDeduplicationResult,
  memoryBreakDistinct,
}
  from "@/services/memoryBank"
import {
  termRemoveDeduplication,
  termBreakDistinct,
  termDeduplication,
}
  from "@/services/term"
export default {
  name: "duplicateremovalDialog",
  data() {
    return {
      percentage: 0,
      duplicateremovalPendingVisible: false,
      resultInfo: {
        sourceSameTargetDifferent: {},
        sourceTargetSame: {}
      },
      loadingcompleted: false, //加载完成
      timeInfo: {
        timer: null,
        timer1: null
      },
      showTitle: false
    }
  },
  components: {
    DialogsHeader,
    duplicateremovalPending
  },
  props: {
    duplicateremovalVisible: {
      type: Boolean,
      required: true
    },
    bankType: {
      type: String,
      default: "memory"
    }
  },
  methods: {
    mouseOverShowTips(e) {
      let target = e.target
      let textLength = target.clientWidth
      let containerLength = target.scrollWidth
      if (textLength < containerLength) {
        this.showTitle = false;
      } else {
        this.showTitle = true;
      }
    },
    //去重
    async getduplicateremoval() {
      let res = null;
      if (this.bankType === 'memory') {
        res = await memoryRemoveDeduplication()
      } else {
        res = await termRemoveDeduplication()
      }
      if (res.success) {
        let taskKey = res.result.taskKey
        this.timeInfo.timer = window.setInterval(async () => {
          const { result, success } = await getRemoveDeduplicationResult({ taskKey })
          if (success) {
            this.percentage = result.percent
            this.resultInfo.sourceSameTargetDifferent = JSON.parse(result.sourceSameTargetDifferent);
            this.resultInfo.sourceTargetSame = JSON.parse(result.sourceTargetSame)
            if (parseInt(this.percentage) === 100) {
              clearInterval(this.timeInfo.timer);
              this.timeInfo.timer = null;
              this.loadingcompleted = true;
            }
          }
        }, 1500)
      }
    },
    formateStatus(status) {
      switch (status) {
        case 1:
          return this.$t('memoryBankV2.Processed')
          break;
        case 2:
          return this.$t('memoryBankV2.Unhandled')
          break;
        default: 1
          break;
      }
    },
    //中止
    async handlerStop() {
      let res = null;
      if (this.bankType === 'memory') {
        res = await memoryBreakDistinct();
      } else {
        res = await termBreakDistinct();
      }
      if (res.success) {
        this.$emit('handleClose');
        this.percentage = 0;
        clearInterval(this.timeInfo.timer);
        this.timeInfo = {
          timer: null,
        }
      }
    },
    //关闭
    handleClose() {
      this.$emit('handleClose');
      this.loadingcompleted = false;
      this.percentage = 0;
      clearInterval(this.timeInfo.timer);
      this.timeInfo = {
        timer: null,
      }
    },
    //去处理
    tohandle() {
      this.$emit('tohandle')
      this.duplicateremovalPendingVisible = true;
      this.$refs.duplicateremovalpending.getmemoryDeduplication(1);
    },
    handlerto(dealCount) {
      if (dealCount === 0) {
        return;
      }
      this.$emit('tohandle')
      this.duplicateremovalPendingVisible = true;
      this.$refs.duplicateremovalpending.getmemoryDeduplication(1);
    },
    //取消处理
    closepending() {
      this.duplicateremovalPendingVisible = false;
      this.loadingcompleted = false;
      this.percentage = 0;
      this.$emit('closepending')
    },
    //处理去重
    handle() {
      this.$emit('handle')
      this.duplicateremovalPendingVisible = false;
      this.loadingcompleted = false;
      this.percentage = 0;
    },

  },
  destroy() {
    clearInterval(this.timeInfo.timer1);
    clearInterval(this.timeInfo.timer);
    this.timeInfo = {
      timer: null,
      timer1: null
    }
  }
} 
</script>
<style lang="less" scoped>
.duplicateremovalDialog {
  /deep/.duplicateremoval {
    width: 471px;
    background: #ffffff;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0px !important;
    .el-dialog__header {
      padding: 16px 32px;
    }
    .el-dialog__body {
      padding: 0px;
      .duplicateremoval-content {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .el-progress__text {
          font-size: 20px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.9);
        }
        .duplicateremoval-text {
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #606266;
          text-align: center;
          margin-top: 30px;
        }
      }
      .duplicateremovalsuccess-content {
        width: 100%;
        padding: 0 32px;
        box-sizing: border-box;
        .success-img {
          width: 100%;
          height: 120px;
          background: url("../images/mergeSuccess.png") no-repeat center center;
          text-align: center;
          line-height: 230px;
          font-size: 14px;
          font-weight: bold;
          color: #303133;
        }
        .result {
          height: 88px;
          background: #fafcff;
          margin-top: 10px;
          display: flex;
          flex-flow: column;
          justify-content: space-evenly;
          .result-item {
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            box-sizing: border-box;
            .item-title {
              width: 186px;
              font-size: 14px;
              font-weight: 400;
              color: #303133;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .item-num {
              color: #ffa43b;
              font-weight: 400;
              em {
                color: #303133;
              }
            }
            .item-state {
              height: 20px;
              border: 0.5px solid #dcdcdc;
              border-radius: 2px 2px 2px 2px;
              color: #909399;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
              padding: 0 8px;
            }
            .tohandle {
              color: #ffffff;
              background: #0078fc;
              border: none;
              cursor: pointer;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 20px 0px 32px 0px;
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
  }
}
</style>